import React from 'react'

import Button from './Button'
import CloseIcon from '../../../assets/icons/close.svg?react'
import useScreenSize from '../../../hocs/useScreenSize'
import { useI18N } from '../../../libraries/i18n/hook'

type Props = { onClick: () => void }
const CloseButton: React.FC<Props> = ({ onClick }) => {
  const { isSm } = useScreenSize()
  const { t } = useI18N()

  return (
    <Button size={isSm ? 'sm' : 'lg'} icon={<CloseIcon />} onClick={onClick} variant='flat'>{isSm ? t('common.close') : ''}</Button>
  )
}

export default CloseButton
